
import React from "react";

const Contact =()=>{
    return (
        <div className="contact">
            <input type="text" placeholder="name"/>
            <input type="text" placeholder='message'/>
            <h1>For any issues with delivery,Contact us
            </h1>
            <button>Contact Us</button>
        </div>
    )
}

export default Contact;